/* globals urls, validate */

var $ = jQuery.noConflict();

window.SymposiumRegistration = function(){
	this.initData = {};
	this.ignoreDataChanges = false;
	this.totalSelector = '#registation-total';
	this.formSelector = '.symposium-registration-form';
};

// Helper function to check if the user navigated to the current page using the back button, and force a refresh if so
SymposiumRegistration.prototype.refreshOnBackNavigation = function(){
	try{
		var navType = window.performance.navigation.type;
		// If the navigation type reprsents the user's back/forward button, force the browser to refresh the page
		// This is used to ensure a user doesn't navigate back to a page they shouldn't have access to after taking an action
		// i.e. They just added the Scientific Program to their cart, hit back, and don't receive a message that the program is already in their cart
		if( navType === 2 ){
			// Trigger form loading state
			this.updateLoadingState( true );
			window.location.reload( true );
		}
	}
	catch( error ){
		// Remove form loading state
		this.updateLoadingState( false );
		console.log( 'The following error occurred while checking for back/forward navigation', error );
	}
};

// Helper function to check the specified values object values HTML tags
SymposiumRegistration.prototype.checkForTags = function(objValues){
	var objFormConstraints = {};
	$.each(objValues, function(key, value){
		objFormConstraints[key] = {noTags: true};
	});
	
	return validate(objValues, objFormConstraints);
};

// Helper function to validate the specified form values against a set of constraints, and to check for tags in the values
SymposiumRegistration.prototype.validate = function(objValues, objConstraints){
	var objTagValidationErrors = this.checkForTags(objValues);
	if(objTagValidationErrors){
		return objTagValidationErrors;
	}
	
	var objValidationErrors = validate(objValues, objConstraints);
	
	return objValidationErrors;
};

// Helper function to set the initial data for this form
SymposiumRegistration.prototype.setInitData = function(objData){
	this.initData = JSON.stringify(objData);
};

// Helper function to check for any changes made to this registration form, based on previously-saved initData from the initial state of the form
// Always returns false if the ignoreDataChanges property is set to true (to allow for redirection after successful registration/update)
SymposiumRegistration.prototype.dataHasChanged = function(objCurrentData){
	if(this.ignoreDataChanges === true){
		return false;
	}
	return this.initData !== JSON.stringify(objCurrentData);
};

// Update total display on the page
SymposiumRegistration.prototype.updateTotal = function(total){
	$(this.totalSelector).html('$' + total);
};

// Update loading state of the form
SymposiumRegistration.prototype.updateLoadingState = function(loading){
	if(loading){
		$(this.formSelector).addClass('loading');
	}
	else{
		$(this.formSelector).removeClass('loading');
	}
};

// Remove validation errors from the form
SymposiumRegistration.prototype.clearRegistrationErrors = function(strMessageSelector){
	$(strMessageSelector).html('');
	$('.error').removeClass('error');
	$('span.validation-error').remove();
};

// Show validation errors on the form
SymposiumRegistration.prototype.showRegistrationErrors = function(strMessageSelector, objValidationResult, title, text){
	var self = this;
	// Make AJAX call to render the twig message partial with a generic error message
	$.ajax({
		method: "POST",
		url: urls.ajax,
		data: { action: 'symp_validation_error', title: title, text: text }
	})
	.done(function( res ) {
		// Add the generic error message to the top of this step, and scroll the window there
		if(res && res.success){
			$(strMessageSelector).html(res.data.message);
			window.scrollTo(0,0);
		}
		// Highlight fields and add error messages based on objValidationResult
		self.addFieldValidationErrorStylesAndMessages(objValidationResult);
		// Remove loading animation if necessary
		self.updateLoadingState(false);
	});
};


// Add validation error messages to form fields
SymposiumRegistration.prototype.addFieldValidationErrorStylesAndMessages = function(objValidationResult){
	$.each(objValidationResult, function(key, value){
		var strErrorMessage = '<span class="validation-error">'+value[0]+'</span>';
		var el;
		switch(key){
			// Dropdowns have a div wrapped around them, so they need to be handed differently
			case 'ShirtSize':
			case 'AddressState':
			case 'Relationship':
			case 'EmergencyContactRelationship':
				el = $('select[name="'+key+'"]').parent('.selectbox-container');
				el.addClass('error');
				el.prevAll('label').addClass('error');
				el.after(strErrorMessage);
				break;
			// Radio buttons have error classes/messages applied to their "parent" label
			case 'AttendingSymposium':
			case 'Gender':
			case 'FirstTimeAttendee':
				el = $('input[name="'+key+'"]').prevAll('label.required');
				el.addClass('error');
				el.after(strErrorMessage);
				break;
			// Special case for rendering validation error when user hasn't selected enough
			case 'SelectedDailyActivities':
				el = $('#symposium-add-on-activities-label');
				el.addClass('error');
				el.after(strErrorMessage);
				break;
			// Normal inputs (e.g. text, email, etc...) have error class applied directly to input and label, and error message after the input
			default:
				el = $('input[name="'+key+'"]');
				el.addClass('error');
				el.prevAll('label').addClass('error');
				el.after(strErrorMessage);
				break;
		}
	});
};
